import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./request";

export function useGetUserCompanies(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['userCompanies', payload],
        async () => await api.get('/api/v1/companies/user_companies', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    return { 
      userCompanies: items || [], 
      isFetching, 
      refetch 
    };
    //return { userCompanies: (data || {}).data || [], isFetching, refetch };
}

export function useGetForms(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['stateMappingForms', payload],
        async () => await api.post('/api/ActStateMapping/GetForms', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    return { forms: (data || {}).data || [], isFetching, refetch };
}

export function useGetActivityDocuments(activityId: string) {
    const queryClient = useQueryClient();
    function invalidate() {
        queryClient.invalidateQueries(['activityDocuments', activityId])
    }
    const { data, isFetching } = useQuery(
        ['activityDocuments', activityId],
        async () => await api.get(`/api/v1/todo_details?filters[todo_id_eq]=${activityId}`),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: !!activityId
        }
    );

    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;

    return {
        documents: items || [],
        isFetching, invalidate,
        total: meta.total_count || 0
    };
}

export function useGetVendorActivityDocuments(activityId: string) {
    const queryClient = useQueryClient();
    function invalidate() {
        queryClient.invalidateQueries(['activityDocuments', activityId])
    }
    const { data, isFetching } = useQuery(
        ['activityDocuments', activityId],
        async () => await api.get(`/api/v1/todo_vendor_details?filters[todo_vendor_id_eq]=${activityId}`),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: !!activityId
        }

    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;

    return { documents: items || [], isFetching, invalidate, total: meta.total_count || 0 };
}

export function useGetAllActivities(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['auditorActivities', payload],
        async () => await api.get('/api/v1/todos', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = ((data || { data: {} }).data || {}).items;
    let meta = ((data || { data: { meta: {} } }).data ||{}).meta || {};
    return { 
      activities: items || [],
      total: meta.total_count || 0, 
      isFetching, 
      refetch 
    };
}

export function useGetAllLocationsAudits(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['auditorActivities', payload],
        async () => await api.get('/api/v1/location_audits', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = ((data || { data: {} }).data || {}).items;
    let meta = ((data || { data: { meta: {} } }).data ||{}).meta || {};
    return { 
      activities: items || [],
      total: meta.total_count || 0, 
      isFetching, 
      refetch 
    };
}

export function useGetAllVendorAudits(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['auditorActivities', payload],
        async () => await api.get('/api/v1/vendor_location_audits', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = ((data || { data: {} }).data || {}).items;
    let meta = ((data || { data: { meta: {} } }).data ||{}).meta || {};
    return { 
      activities: items || [],
      total: meta.total_count || 0, 
      isFetching, 
      refetch 
    };
}

export function useGetVendorActivites(payload: any) {
    const { data, isFetching, refetch } = useQuery(
        ['auditorActivities', payload],
        async () => await api.post('/api/ToDo/GetToDoByCriteria', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled: !!payload && !!payload.company
        }
    );

    return { activities: (data || {}).data || [], isFetching, refetch };
}



export function useExportTodos(onSuccess?: any, onError?: any) {
    const { mutate: exportTodos, error, isLoading: exporting } = useMutation(
        ['exportTodos'],
        async (payload: any) => await api.post('/api/v1/todos/export', {
            todo: payload
        }, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportTodos, error, exporting };
}

export function useGetUserVendors(enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['userVendors'],
        async () => await api.get('/api/Company/GetUserVendors'),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return { userVendors: (data || {}).data || [], isFetching, refetch };
}

// Vendor audit activites
export function useGetAllVendorActivities(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['auditorActivities', payload],
        async () => await api.get('/api/v1/todo_vendors', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      activities: items || [],
      total: meta.total_count || 0, 
      isFetching, 
      refetch 
    };
}

export function useExportVendorTodos(onSuccess?: any, onError?: any) {
    const { mutate: exportTodos, error, isLoading: exporting } = useMutation(
        ['exportTodos'],
        async (payload: any) => await api.post('/api/v1/todo_vendors/export', {todo_vendors: payload}, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response: any) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportTodos, error, exporting };
}

export function useUpdateAuditorVendor(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['updateAuditDetails', payload],
        async () => await api.post('/api/AuditorVendor/UpdateAuditVendorDetails', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return { AuditVendors: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch };
}


export function useSendReportAsEmail(onSuccess?: any, onError?: any) {
    const { mutate: sendEmail, error, isLoading: adding } = useMutation(
        ['sendEmail'],
        async (payload: any) => await api.post('/api/AuditorVendor/SendEmailDownlaodVendorReport', payload),
        {
            onError,
            onSuccess: (response: any) => {
                const { data } = response || {};
                onSuccess(data || {});
            }
        }
    );
    return { sendEmail, error, adding };
}
export function useToDoWithZip(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['multiIds', payload],
        async () => await api.post('api/ToDoVendorDetails/GetByToDowithZipWithOnlyFileforMultipleIds', payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );

    return { multipleIds: (data || {}).data || [], isFetching, refetch };
}


// export function useExportCompanyLocations(onSuccess?: any, onError?: any) {
//     const { mutate: exportCompanyLocations, error, isLoading: exporting } = useMutation(
//         ['exportCompanyLocations'],
//         async (payload: any) => await api.post('/api/Mappings/ExportVendorLocationMappings', payload, null, true, { responseType: 'blob' }),
//         {
//             onError,
//             onSuccess: (response) => {
//                 const data = (response || {});
//                 onSuccess(data);
//             }
//         }
//     );
//     return { exportCompanyLocations, error, exporting };
// }

export function useExportAssociateVendors(onSuccess?: any, onError?: any) {
    const { mutate: exportVendors, error, isLoading: exporting } = useMutation(
        ['exportAssociateCompanies'],
        async (payload: any) => await api.post('/api/VendorDetails/ExportVendors', payload, null, true, { responseType: 'blob' }),
        {
            onError,
            onSuccess: (response: any) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );
    return { exportVendors, error, exporting };
}

export function useVendorImportLocations(onSuccess?: any, onError?: any) {
    const { mutate: VendorImportLocation, error, isLoading: uploading } = useMutation(
        ['VendorImportLocation'],
        async ({ CID, ACID, LID, formData }: any) =>
            await api.post(
                `/api/Mappings/BulkImportVendorLocationsMappings?company_id=${CID}&associate_company_id=${ACID}&location_id=${LID}`,
                formData,
                null,
                true,
                { responseType: 'blob' }
            ),
        {
            onError,
            onSuccess: (response: any) => {
                const data = (response || {});
                onSuccess(data);
            }
        }
    );

    return { VendorImportLocation, error, uploading };
}
